import { ClientFormUserRole, ClientFormUserRoleKeys, TrainingMemberType, TrainingMemberTypeKeys } from '@pbk-web/types';
import type { Namespace, TFunction } from 'i18next';
import { useMemo } from 'react';

export type AvatarRole = {
  role: number;
  requiresAction: boolean;
  roleOrder: number | undefined | null;
  isStepRole: boolean;
};

const useAvatarRoleNames = (roles: AvatarRole | AvatarRole[], t: TFunction<Namespace>) => {
  return useMemo(() => {
    if (!roles) return '';

    const roleArray = Array.isArray(roles) ? roles : [roles];

    return roleArray
      .map((role) => {
        if (role.role === ClientFormUserRole.Owner && role.requiresAction) {
          return t('form-role-tooltip-owner');
        }

        let order = '';
        let actionRequired = '';

        if (role.roleOrder !== undefined && role.roleOrder !== null) {
          order = `#${role.roleOrder + 1}`;
        }
        if (role.role === ClientFormUserRole.Approver || role.role === ClientFormUserRole.Validator) {
          actionRequired = role.requiresAction || role.isStepRole ? t('form-role-requiredness.required') : t('form-role-requiredness.optional');
        }
        if (role.role in TrainingMemberType) {
          return t('form-role-tooltip', {
            actionRequired,
            role: t(TrainingMemberTypeKeys[role.role as TrainingMemberType]),
            order,
          });
        } else {
          return t('form-role-tooltip', {
            actionRequired,
            role: t(ClientFormUserRoleKeys[role.role as keyof typeof ClientFormUserRoleKeys]),
            order,
          });
        }
      })
      .map((roleText, index) => (
        <div key={index} className="text-nowrap">
          {roleText}
        </div>
      ));
  }, [roles, t]);
};

export default useAvatarRoleNames;
